'use client';

import { FC } from 'react';
import { useImageObserver } from '@/hooks';
import noImage from '@/assets/webp/no-image.webp';

interface GalleryThumbImageProps {
  src?: string | null;
}

export const GalleryThumbImage: FC<GalleryThumbImageProps> = ({ src }) => {
  const { imgSrc, handleError, handleLoad } = useImageObserver(src, true);

  return (
    <img
      src={imgSrc ?? noImage.src}
      alt=""
      onError={handleError}
      onLoad={handleLoad}
      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
    />
  );
};
